/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1PersonIdTeacherData200,
  GetApiV1PersonIdTeacherData401,
  GetApiV1PersonIdTeacherData404,
  GetApiV1PersonIdTeacherData500,
  GetApiV1PersonIdTeacherDataPathParams,
  GetApiV1PersonIdTeacherDataQueryResponse,
} from "../../types/personTeacherController/GetApiV1PersonIdTeacherData.ts";
import { personTeacherDataViewModelSchema } from "../personTeacherDataViewModelSchema.ts";

export const getApiV1PersonIdTeacherDataPathParamsSchema = z.object({
  id: z.coerce.number().int(),
}) as unknown as ToZod<GetApiV1PersonIdTeacherDataPathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1PersonIdTeacherData200Schema = z.lazy(
  () => personTeacherDataViewModelSchema,
) as unknown as ToZod<GetApiV1PersonIdTeacherData200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1PersonIdTeacherData401Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdTeacherData401>;

/**
 * @description (Not Found) Registro não encontrado.
 */
export const getApiV1PersonIdTeacherData404Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdTeacherData404>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1PersonIdTeacherData500Schema =
  z.any() as unknown as ToZod<GetApiV1PersonIdTeacherData500>;

export const getApiV1PersonIdTeacherDataQueryResponseSchema = z.lazy(
  () => getApiV1PersonIdTeacherData200Schema,
) as unknown as ToZod<GetApiV1PersonIdTeacherDataQueryResponse>;
